import type { ReactNode } from 'react'
import { NavLink, Outlet } from 'react-router-dom'

import { useAuth } from '../auth/AuthProvider.tsx'
import { PilihTema } from './PilihTema.tsx'
import type { RoleGrant } from '../api/auth.api.js'

/**
 * Menu sadar peran — W1-B03.
 *
 * Ini **kenyamanan, bukan kontrol**. Penegakan yang mengikat ada pada guard di
 * server; menyembunyikan tautan hanya mencegah pengguna menemui 403 yang
 * membingungkan. Halaman yang disembunyikan di sini tetap harus menolak bila
 * alamatnya diketik langsung — dan memang begitu, karena penolakannya terjadi
 * di server.
 */
interface MenuItem {
  readonly to: string
  readonly label: string
  readonly roles: readonly string[]
}

const MENU: readonly MenuItem[] = [
  { to: '/peserta', label: 'Peserta', roles: ['PANITIA_PUSAT', 'PANITIA_TUK'] },
  {
    to: '/tuk',
    label: 'TUK',
    roles: ['PANITIA_PUSAT', 'KOORDINATOR_REGIONAL', 'KOORDINATOR_TUK', 'PANITIA_TUK', 'LABORAN'],
  },
  {
    to: '/perangkat',
    label: 'Perangkat',
    roles: ['PANITIA_PUSAT', 'KOORDINATOR_REGIONAL', 'KOORDINATOR_TUK', 'PANITIA_TUK'],
  },
  { to: '/katalog', label: 'Katalog Station', roles: ['PANITIA_PUSAT', 'AUDITOR'] },
  { to: '/blueprint', label: 'Blueprint', roles: ['PANITIA_PUSAT', 'AUDITOR'] },
  // Koordinator dan panitia TUK kini ikut, setelah daftarnya disaring per TUK
  // dan isi sirkuit disembunyikan dari cakupan non-nasional. Mereka melihat
  // keadaan snapshot sesinya — dan dapat membuka amplop kunci luring saat WAN
  // putus — tanpa pernah melihat kode maupun judul station-nya.
  {
    to: '/snapshot',
    label: 'Snapshot',
    roles: ['PANITIA_PUSAT', 'AUDITOR', 'KOORDINATOR_TUK', 'PANITIA_TUK'],
  },
  { to: '/naskah', label: 'Naskah', roles: ['PANITIA_PUSAT', 'AUDITOR'] },
  {
    to: '/kredensial-luring',
    label: 'Kredensial Luring',
    roles: ['PANITIA_PUSAT', 'KOORDINATOR_REGIONAL', 'KOORDINATOR_TUK'],
  },
  { to: '/audit', label: 'Audit', roles: ['PANITIA_PUSAT', 'AUDITOR'] },
]

export function boleh(grants: readonly RoleGrant[] | undefined, roles: readonly string[]): boolean {
  return grants?.some((g) => roles.includes(g.role)) ?? false
}

export function Shell(): ReactNode {
  const { user, logout } = useAuth()
  const terlihat = MENU.filter((item) => boleh(user?.roles, item.roles))

  return (
    <div className="shell">
      <header className="topbar">
        <nav className="topbar-nav">
          <strong>CBT/CBS-OSCE</strong>
          <NavLink to="/" end>
            Beranda
          </NavLink>
          {terlihat.map((item) => (
            <NavLink key={item.to} to={item.to}>
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="topbar-right">
          <PilihTema />
          {/* Nama pengguna adalah jalan masuk ke profil — tempat peran dan
              penggantian kata sandi berada. */}
          <NavLink to="/profil" className="topbar-profil">
            {user?.fullName}
          </NavLink>
          <button onClick={() => void logout()}>Keluar</button>
        </div>
      </header>
      <main className="content">
        <Outlet />
      </main>
    </div>
  )
}
